(() => {
  if (window.__FAJ_RELATED_SERVICES_V2__) return;
  window.__FAJ_RELATED_SERVICES_V2__ = true;

  const instances = new WeakMap();

  class FAJRelatedServices {
    constructor(section) {
      this.section = section;
      this.carousel = section.querySelector('[data-fajrs-carousel]');

      this.enabled = section.dataset.enableSlider === 'true';
      this.wrapAround = section.dataset.wrapAround === 'true';
      this.showArrows = section.dataset.showArrows === 'true';
      this.showDots = section.dataset.showDots === 'true';

      this.flickity = null;
      this.waitTimer = null;
      this.waitAttempts = 0;
    }

    init() {
      if (!this.enabled || !this.carousel) return;
      if (this.carousel.children.length < 2) return;

      this.waitForFlickity();
    }

    waitForFlickity() {
      if (typeof window.Flickity !== 'undefined') {
        this.createFlickity();
        return;
      }

      this.waitAttempts += 1;

      if (this.waitAttempts > 60) {
        console.warn(
          'FAJ related services: Flickity was not available on this page.'
        );
        return;
      }

      this.waitTimer = window.setTimeout(
        () => this.waitForFlickity(),
        100
      );
    }

    createFlickity() {
      if (this.flickity) return;

      this.section.classList.add('is-flickity');

      this.flickity = new window.Flickity(this.carousel, {
        cellAlign: 'left',
        contain: true,
        draggable: true,
        prevNextButtons: this.showArrows,
        pageDots: this.showDots,
        wrapAround: this.wrapAround,
        groupCells: false,
        percentPosition: true,
        adaptiveHeight: false,
        setGallerySize: true,
        accessibility: true,
        selectedAttraction: 0.025,
        friction: 0.28
      });

      window.requestAnimationFrame(() => {
        this.flickity?.resize();
      });
    }

    destroy() {
      if (this.waitTimer) {
        window.clearTimeout(this.waitTimer);
      }

      this.flickity?.destroy();
      this.flickity = null;
      this.section.classList.remove('is-flickity');
    }
  }

  const initSection = (section) => {
    if (!section || instances.has(section)) return;

    const instance = new FAJRelatedServices(section);
    instances.set(section, instance);
    instance.init();
  };

  const destroySection = (section) => {
    const instance = instances.get(section);
    if (!instance) return;

    instance.destroy();
    instances.delete(section);
  };

  const initAll = (root = document) => {
    if (root.matches?.('[data-fajrs]')) {
      initSection(root);
    }

    root.querySelectorAll?.('[data-fajrs]').forEach(initSection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    if (event.target.matches?.('[data-fajrs]')) {
      destroySection(event.target);
    }

    event.target
      .querySelectorAll?.('[data-fajrs]')
      .forEach(destroySection);
  });
})();
